import React from "react";
import Button from "./Button";

function ButtonsContainer({ handleClick, operatorClick, handleEqual }) {
  return (
    <div className="btn-wrapper">
      <div className="btn-container">
        <Button handleClick={handleClick} name="(" value="(" />
        <Button handleClick={handleClick} name=")" value=")" />
        <Button handleClick={() => operatorClick("^")} name="^" value="^" />
        <Button handleClick={handleEqual} className="colored-btn" name="=" value="=" />
      </div>
      <div className="btn-container">
        <Button handleClick={handleClick} name="7" value="7" />
        <Button handleClick={handleClick} name="8" value="8" />
        <Button handleClick={handleClick} name="9" value="9" />
        <Button handleClick={() => operatorClick("/")} className="colored-btn" name="/" value="/" />
      </div>
      <div className="btn-container">
        <Button handleClick={handleClick} name="4" value="4" />
        <Button handleClick={handleClick} name="5" value="5" />
        <Button handleClick={handleClick} name="6" value="6" />
        <Button handleClick={() => operatorClick("*")} className="colored-btn" name="*" value="*" />
      </div>
      <div className="btn-container">
        <Button handleClick={handleClick} name="1" value="1" />
        <Button handleClick={handleClick} name="2" value="2" />
        <Button handleClick={handleClick} name="3" value="3" />
        <Button handleClick={() => operatorClick("-")} className="colored-btn" name="-" value="-" />
      </div>
      <div className="btn-container">
        <Button handleClick={handleClick} name="0" value="0" />
        <Button handleClick={handleClick} name="." value="." />
        <Button handleClick={handleClick} name="π" value="π" />
        <Button handleClick={() => operatorClick("+")} className="colored-btn" name="+" value="+" />
      </div>
      <div className="btn-container">
        <Button handleClick={handleClick} name="sin(" value="sin" />
        <Button handleClick={handleClick} name="cos(" value="cos" />
        <Button handleClick={handleClick} name="tan(" value="tan" />
        <Button handleClick={handleClick} name="log(" value="log" />
      </div>
      <div className="btn-container">
        <Button handleClick={handleClick} name="sqrt(" value="√" />
        <Button handleClick={() => operatorClick("e")} name="e" value="e" />
        <Button handleClick={handleClick} name="exp(" value="exp" />
        <Button handleClick={handleClick} name="mod" value="mod" />
      </div>
    </div>
  );
}

export default ButtonsContainer;
